<template>
  <form class="column is-12" @submit.prevent="onSubmit">
    <div class="columns is-multiline">
      <div class="column is-12">
        <h3 class="title is-5">Identificación de producto</h3>
      </div>
      <div class="column is-8">
        <div class="field">
          <input type="text" class="input" id="productDescription" v-model="productIdentification.productDescription" placeholder="Descripción de producto">
        </div>
        <div class="field">
          <input type="text" class="input" id="reference" v-model="productIdentification.reference" placeholder="Referencia">
        </div>
        <div class="field">
          <input type="text" class="input" id="barCode" v-model="productIdentification.barCode" placeholder="Código de barras">
        </div>
        <div class="field">
          <input type="text" class="input" id="brand" v-model="productIdentification.brand" placeholder="Marca">
        </div>
        <div class="field">
          <input type="text" class="input" id="shopPlace" v-model="productIdentification.shopPlace" placeholder="Lugar de compra (Almacen de cadena, tienda,  sucursal)">
        </div>
        <div class="field">
          <input type="text" class="input" id="invoice" v-model="productIdentification.invoice" placeholder="Número factura">
        </div>
        <div class="field">
          <label for="datePurchase">Fecha de compra del producto:</label>
          <input type="date" class="input" id="datePurchase" v-model="productIdentification.datePurchase" placeholder="Fecha de compra">
        </div>
        <div class="field">
          <input type="checkbox" id="provider" v-model="productIdentification.provider">
          <label for="provider">Soy distribuidor</label>
        </div>
      </div>
      <div class="column is-6">
        <button class="button is-black" :disabled="!productIdentification.reference || !productIdentification.barCode || !productIdentification.brand || !productIdentification.invoice || !productIdentification.datePurchase">Continuar</button>
      </div>
    </div>
  </form>
</template>

<script>
export default {
  name: "ProductIdentification",
  data() {
    return {
      productIdentification: {
        productDescription: '',
        reference: '',
        barCode: '',
        brand: '',
        shopPlace: '',
        invoice: '',
        datePurchase: '',
        provider: ''
      }
    }
  },
  methods: {
    onSubmit() {
      this.$emit('done', {
        key: 'productIdentification',
        productIdentification: this.productIdentification
      });
    }
  }
}
</script>


<style lang="scss" scoped>
.field, .column {
  a {
    color: #ffffff;
    font-weight: bold;
  }
}
</style>
